import { Box } from '@themed';
import { ChildrenProps } from '@types';
import React from 'react';
import { SxProps } from 'theme-ui';

export const PostContentContainer = ({ children, sx }: ChildrenProps & SxProps) => (
  <Box sx={{ variant: 'styles.blogTextMaxWidth', ...sx }}>{children}</Box>
);
